module.exports = __webpack_public_path__ + "img/dmf.152c8aee.png";